export const otpAuthenticatorActions = [
  {
    name: 'generateEmailOTP',
    label: 'Generate Email OTP',
    args: [
      {
        name: 'otpAuthenticationType',
        label: 'Select Authentication Type',
        type: 'dropdown',
        optionsType: 'otpAuthenticationType',
        options: [
          {
            label: 'Login',
            value: 'login',
          },
          {
            label: 'Sign Up',
            value: 'signUp',
          },
        ],
        value: 'login',
      },
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'verifyEmailOTP',
    label: 'Verify Email OTP and Login',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'generateSmsOTP',
    label: 'Generate SMS OTP',
    args: [
      {
        name: 'otpAuthenticationType',
        label: 'Select Authentication Type',
        type: 'dropdown',
        optionsType: 'otpAuthenticationType',
        options: [
          {
            label: 'Login',
            value: 'login',
          },
          {
            label: 'Sign Up',
            value: 'signUp',
          },
        ],
        value: 'login',
      },
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'smsTemplate',
        label: 'Select SMS Template',
        type: 'dropdown',
        optionsType: 'smsTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'verifySmsOTP',
    label: 'Verify SMS OTP and Login',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'generateUserConsentEmailOTP',
    label: 'Generate User Consent Email OTP',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'userEmailField',
        label: 'Select User Email Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'dataOperationType',
        label: 'Data Operation',
        type: 'dropdown',
        optionsType: 'dataOperationType',
        options: [
          {
            label: 'Save',
            value: 'save',
          },
          {
            label: 'Update',
            value: 'update',
          },
        ],
        value: 'save',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'verifyUserConsentEmailOTP',
    label: 'Verify Email Consent OTP and Save Data',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'generateUserConsentSmsOTP',
    label: 'Generate User Consent SMS OTP',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'smsTemplate',
        label: 'Select SMS Template',
        type: 'dropdown',
        optionsType: 'smsTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'userMobileField',
        label: 'Select User Phone Number Field',
        type: 'dropdown',
        optionsType: 'collectionFieldApi',
        options: [],
        value: '',
      },
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'dataOperationType',
        label: 'Data Operation',
        type: 'dropdown',
        optionsType: 'dataOperationType',
        options: [
          {
            label: 'Save',
            value: 'save',
          },
          {
            label: 'Update',
            value: 'update',
          },
        ],
        value: 'save',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
  {
    name: 'verifyUserConsentSmsOTP',
    label: 'Verify SMS Consent OTP and Save Data',
    args: [
      {
        name: 'collection',
        label: 'Select Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'successRedirectUrl',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'successMessage',
        label: 'Success Message',
        type: 'text',
        value: '',
      },
      {
        name: 'errorMessage',
        label: 'Error Message',
        type: 'text',
        value: '',
      },
    ],
  },
];
